<template>
    <span class="base-count-badge scaffold-details-bold" :class="{ 'base-count-badge-ringed': ringed }">
        <span class="base-count-badge-digits">{{ displayCount }}</span>
    </span>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
    defineProps<{
        count: number;
        max?: number;
        // Separates the badge from the icon it overlaps; turn off when it sits inline.
        ringed?: boolean;
    }>(),
    {
        max: 99,
        ringed: true,
    },
);

const displayCount = computed(() => (props.count > props.max ? `${props.max}+` : `${props.count}`));
</script>

<style scoped>
@reference "../../../css/tailwind.css";

@layer components {
    .base-count-badge {
        @apply inline-flex h-4.5 min-w-4.5 shrink-0 items-center justify-center rounded-full bg-count-badge-bg px-1 leading-none text-count-badge-text tabular-nums;
    }

    /* text-box-trim only applies to block containers, not the flex container's anonymous item; trimming
       to cap height centres the digits optically instead of by the font's ascent/descent. */
    .base-count-badge-digits {
        @apply block;
        text-box: trim-both cap alphabetic;
    }

    .base-count-badge-ringed {
        @apply ring-2 ring-count-badge-ring;
    }
}
</style>
